module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.woff?feebb35df70e880afc63dbc034a8f305]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-Bold.woff
// module id = 1880
// module chunks = 32